module.exports = __webpack_public_path__ + "img/ico_zhdd.a57f84bf.png";